import { render, staticRenderFns } from "./VonexRadio.vue?vue&type=template&id=7020232c&"
import script from "./VonexRadio.vue?vue&type=script&lang=js&"
export * from "./VonexRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadioGroup})
